import createSharedStateHook from '../../../../Cart/UI/templates/js/Shared/use-shared-state';

export const useModalIsOpen = createSharedStateHook('modelIsOpen');
export const setModalIsOpen = useModalIsOpen.set;
